import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";
import { TIP_BAR_HEIGHT } from "../shared/constants";
import { addSvg } from "../shared/utils";

export default class AbstractSideBar extends AbstractProvidedClass {
    tabContainer;
    tabs;
    menuStart = 0;
    config = {
        'search': { icon: 'add-circle-line', activeIcon: 'add-circle-fill', tooltip: 'Add a plant (S)' },
        'lists': { icon: 'list-unordered', activeIcon: 'list-view', tooltip: 'Lists (L)' },
        'info': { icon: 'information-line', activeIcon: 'information-fill', tooltip: 'Info (I)' },
        'elements': { icon: 'shapes-line', activeIcon: 'shapes-fill', tooltip: 'Elements (T)' },
        'plants': { icon: 'plant-line', activeIcon: 'plant-fill', tooltip: 'Plants (P)' },
        'layers': { icon: 'stack-line', activeIcon: 'stack-fill', tooltip: 'Layers (Y)' },
    };

    init() {
        this.menuWidth = 40;
        this.bottomOffset = this.editMode ? TIP_BAR_HEIGHT : 0;

        this.menuContainer = this.p.createDiv('')
            .parent('#p5canvas')
            .id('sidebar-menu')
            .style('position', 'fixed')
            .style('top', '0px')
            .style('right', '0px')
            .style('width', `${this.menuWidth}px`)
            .style('height', `calc(100dvh - ${this.bottomOffset}px)`)
            .style('background-color', '#fff')
            .style('border-left', '2px solid #000')
            .style('display', 'flex')
            .style('flex-direction', 'column')
            .style('z-index', '9')
            .style('overflow', 'visible');

        this.createButtons();

        this.width = 300;

        this.tabContainer = this.p.createDiv().parent('#p5canvas')
            .id('sidebar')
            .style('position', 'fixed')
            .style('right', `${this.menuWidth}px`)
            .style('top', '0px')
            .style('width', `${this.width}px`)
            .style('height', `calc(100dvh - ${this.bottomOffset}px)`)
            .style('background-color', '#fff')
            .style('border-left', '2px solid #000')
            .style('overflow-x', 'hidden')
            .style('overflow-y', 'auto')
            .style('z-index', 8);

        this.setupSidebarTooltips();

        this.on(EventTypes.TIMELINE_TOGGLED, (barHeight) => {
            this.bottomOffset = TIP_BAR_HEIGHT + barHeight;
            this.updateHeight();
        });

        if (this.mobile) {
            this.isOpen = false;
            this.tabContainer.hide();
            this.closeButton.hide();
            this.openButton.show();
        } else {
            this.isOpen = true;
        }

        // this.on(EventTypes.RESIZE_WINDOW, () => this.resizeWindow());
    }

    updateHeight() {
        let h = `calc(100dvh - ${this.bottomOffset}px)`;
        this.menuContainer.style('height', h);
        this.tabContainer.style('height', h);
    }

    resizeWindow() {
        // this.x = this.x = this.p.width - (this.isOpen ? this.width : 0);
        // this.tabContainer.position(this.x - this.labelWidth, 0);
        // Object.values(this.tabs).map((tab) => tab.resizeWindow());
    }

    setupSidebarTooltips() {
        let tooltip = document.createElement('div');
        tooltip.style.cssText = 'position:fixed;z-index:20;padding:0.15rem 0.5rem;background:var(--color-gray-500);border-radius:0.5rem;color:#fff;white-space:nowrap;font-size:0.85em;pointer-events:none;display:none;';
        document.getElementById('p5canvas').appendChild(tooltip);

        let currentTarget = null;
        let sidebarEl = this.tabContainer.elt;

        let show = (target) => {
            currentTarget = target;
            tooltip.textContent = target.getAttribute('data-tooltip');
            let rect = target.getBoundingClientRect();
            tooltip.style.display = 'block';
            tooltip.style.left = (rect.left + rect.width / 2 - tooltip.offsetWidth / 2) + 'px';
            tooltip.style.top = (rect.top - tooltip.offsetHeight * 0.8) + 'px';
        };

        let hide = () => {
            currentTarget = null;
            tooltip.style.display = 'none';
        };

        sidebarEl.addEventListener('mouseover', (e) => {
            let target = e.target.closest('[data-tooltip]');
            if (!target || !sidebarEl.contains(target)) {
                if (currentTarget) hide();
                return;
            }
            if (target !== currentTarget) show(target);
        });

        sidebarEl.addEventListener('mouseout', (e) => {
            if (!currentTarget) return;
            let related = e.relatedTarget;
            if (!related || !currentTarget.contains(related)) hide();
        });
    }

    createButtons() {
        this.createOpenCloseButton();
        this.buttons = {};
        this.options.map( name => {
            this.buttons[name] = this.createButton(name, this.config[name].icon, this.config[name].tooltip);
        });
    }

    createOpenCloseButton() {
        this.openCloseButtonContainer = this.p.createDiv()
                .parent(this.menuContainer)
                .size(this.menuWidth, this.menuWidth)
                .style('display', 'flex')
                .style('flex-direction', 'column')
                .style('align-items', 'center')
                .style('justify-content', 'center')
                .style('background', '#B8E9E4')
                .style('border-bottom', '2px solid #000');

        this.closeButton = this.p.createDiv()
            .parent(this.openCloseButtonContainer)
            .class('planner-tab-arrow -u-tt-bottom')
            .attribute('data-tooltip', 'Close sidebar')
            .mousePressed(() => this.emit(EventTypes.CLOSE_SIDEBAR));
        addSvg(this.closeButton, 'arrow-right-line');

        this.openButton = this.p.createDiv()
            .parent(this.openCloseButtonContainer)
            .class('planner-tab-arrow -u-tt-bottom')
            .attribute('data-tooltip', 'Open sidebar')
            .mousePressed(() => this.emit(EventTypes.OPEN_SIDEBAR));
        addSvg(this.openButton, 'arrow-left-line');

        this.openButton.hide();

        this.on(EventTypes.OPEN_SIDEBAR, () => {
            this.open();
            this.closeButton.show();
            this.openButton.hide();
        });
        this.on(EventTypes.CLOSE_SIDEBAR, () => {
            this.close();
            this.closeButton.hide();
            this.openButton.show();
        });
    }

    setButtonIcon(btn, icon) {
        btn.html(`<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#${icon}"></use></svg>`);
    }

    createButton(name, icon, tooltip) {
        let wrapper = this.p.createDiv('')
            .parent(this.menuContainer)
            .size(this.menuWidth, this.menuWidth)
            .style('display', 'flex')
            .style('flex-direction', 'column')
            .style('align-items', 'center')
            .style('justify-content', 'center');

        let btn = this.p.createDiv()
            .parent(wrapper)
            .size(this.menuWidth, this.menuWidth-2)
            .style('border', 'none')
            .style('background', 'transparent')
            .class('planner-tab')
            .attribute('data-tooltip', tooltip)
            .mousePressed(() => this.sideBar.setTab(name));

        this.setButtonIcon(btn, icon);

        let separator = this.p.createDiv('')
            .parent(wrapper)
            .size(this.menuWidth * 0.7, 1)
            .style('background', '#333');

        return btn;
    }

    hovered() {
        return this.p.mouseX > (
            this.p.windowWidth - (
                this.menuWidth + (this.isOpen ? this.width : 0)
            )
        );
    }

    setTab(tab) {
        if (this.openTab) {
            let openTab = this.openTab.name;
            this.buttons[openTab].removeClass('-is-active');
            this.setButtonIcon(this.buttons[openTab], this.config[openTab].icon);
            this.openTab.deactivate();
        }

        this.openTab = this.tabs[tab];
        this.openTab.activate();
        this.buttons[tab].addClass('-is-active');
        this.setButtonIcon(this.buttons[tab], this.config[tab].activeIcon);
        this.emit(EventTypes.OPEN_SIDEBAR);
    }

    open() {
        this.isOpen = true;
        this.tabContainer.show();
        // this.resizeWindow();
        this.openTab.activate();
    }

    close() {
        this.isOpen = false;
        this.tabContainer.hide();
        // this.resizeWindow();
        this.openTab.deactivate();
    }
}
